import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53695154"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "profile-friends-friends"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Friends", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderCircle = _resolveComponent("LoaderCircle")!
  const _component_BlockProfileFriendList = _resolveComponent("BlockProfileFriendList")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_LoaderCircle, { key: 0 }))
    : (_ctx.friends.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_BlockProfileFriendList, {
            friends: _ctx.friends,
            "horizontal-slide": _ctx.horizontalSlide,
            "vertical-slide": _ctx.verticalSlide,
            onOnFriendMutated: _ctx.loadUsers
          }, null, 8, ["friends", "horizontal-slide", "vertical-slide", "onOnFriendMutated"])
        ]))
      : _createCommentVNode("", true)
}